export default {
  addresss: [
    {
      title: 'Eddy',
      add: 'FuTian district Shenzhen CHINA',
      phone: '[0755] 8350 9090',
      email: 'eddy.guo@fxs-tech.com.cn'
    },
    /*
    {
      title: 'SAN LEADO ROOM',
      add: '911 FARWAY DRIVE',
      phone: '[070] 722 1000',
      email: 'sales@maxgiftexporter.com'
    }
    */
  ]
}


// WEBPACK FOOTER //
// ./src/pages/home/components/footer/config.js